// extracted by mini-css-extract-plugin
export default {"quick-add-products-by-stock-container":"quick-add-products-by-stock-component_quick-add-products-by-stock-container__etWws"};